import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FloatButton } from "antd";
import "./styles.css";
import DisplaySettings from "../../pages/super-admin/Components/DisplaySettings";
import { selectTheme, setTheme } from "../../redux/features/appSlice";
import ReportBug from "../UserHelp/ReportBug";
import TranslateSite from "../UserHelp/Translate";
import UserTour from "../tour";
import { selectUserDoc } from "../../redux/features/userSlice";
import { getCurrentPlan } from "../../helper/plans";
import useSize from "../../hooks/useSize";
import { useNavigate } from "react-router-dom";
import { routePath } from "../../static/routes.static";
import SustraxBot from "../../pages/chatbot";
import RequestFeature from "../UserHelp/RequestFeature";
import Access from "./Access";

const FloatingButtons = ({ refetchData, headerMode = false }) => {
  const dispatch = useDispatch();
  const user = useSelector(selectUserDoc);
  const { isSmall, isExtraSmall } = useSize();
  const { isDarkMode } = useSelector(selectTheme);
  const navigate = useNavigate();
  const { isMobile } = useSize();

  const [display, setDisplay] = useState({
    superAdminModal: false,
    reportBug: false,
    translate: false,
    tutorial: false,
    ai_bot: false,
    access: false,
    requestFeature: false,
  });

  const toggleModal = (key) => {
    setDisplay((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  useEffect(() => {
    if (user && getCurrentPlan() === "free" && !user.tut_shown_on && !user.tut_completed_on) {
      toggleModal("tutorial");
    }
  }, [user]);

  const toggleDarkMode = () => {
    const isDarkMode = document.body.classList.contains("sustrax-dark");
    dispatch(setTheme({ isDarkMode: !isDarkMode }));
  };

  // Listen for custom events from header
  useEffect(() => {
    const openSuperAdminModal = () => toggleModal("superAdminModal");
    const openReportBug = () => toggleModal("reportBug");
    const openRequestFeature = () => toggleModal("requestFeature");
    const openTranslate = () => toggleModal("translate");
    const openTutorial = () => toggleModal("tutorial");
    const openAccessibility = () => toggleModal("access");

    document.addEventListener('openSuperAdminModal', openSuperAdminModal);
    document.addEventListener('openReportBug', openReportBug);
    document.addEventListener('openRequestFeature', openRequestFeature);
    document.addEventListener('openTranslate', openTranslate);
    document.addEventListener('openTutorial', openTutorial);
    document.addEventListener('openAccessibility', openAccessibility);
    document.addEventListener('toggleDarkMode', toggleDarkMode);

    return () => {
      document.removeEventListener('openSuperAdminModal', openSuperAdminModal);
      document.removeEventListener('openReportBug', openReportBug);
      document.removeEventListener('openRequestFeature', openRequestFeature);
      document.removeEventListener('openTranslate', openTranslate);
      document.removeEventListener('openTutorial', openTutorial);
      document.removeEventListener('openAccessibility', openAccessibility);
    };
  }, []);

  const handleAIChatClick = () => {
    if (isMobile) {
      navigate(routePath.chat);
      if (display.ai_bot) {
        //close desktop bot
        setDisplay({});
      }
    } else {
      setDisplay({ ...display, ai_bot: !display.ai_bot });
    }
  };

  // Render only modals for header mode
  if (headerMode) {
    return (
      <>
        {/* Modals */}
        <ReportBug modalVisible={display.reportBug} setModalVisible={(visible) => setDisplay((prev) => ({ ...prev, reportBug: visible }))} />
        <RequestFeature modalVisible={display.requestFeature} setModalVisible={(visible) => setDisplay((prev) => ({ ...prev, requestFeature: visible }))} />
        <TranslateSite visible={display.translate} setVisible={(visible) => setDisplay((prev) => ({ ...prev, translate: visible }))} />
        <DisplaySettings refetchData={refetchData} modalVisible={display.superAdminModal} setModalVisible={(visible) => setDisplay((prev) => ({ ...prev, superAdminModal: visible }))} />
        <Access visible={display.access} setVisible={(visible) => setDisplay((prev) => ({ ...prev, access: visible }))} />
        <UserTour open={display.tutorial} setOpen={(visible) => setDisplay((prev) => ({ ...prev, tutorial: visible }))} />

        {display.ai_bot && (
          <div style={{ position: "fixed", top: "60px", right: "0", zIndex: 1000, width: "350px", height: "calc(100vh - 60px)" }}>
            <SustraxBot fullPage={false} />
          </div>
        )}
      </>
    );
  }

  // Simplified floating buttons for non-header mode - only dark mode toggle
  return (
    <div>
      <FloatButton
        tooltip="Toggle Dark/Light Mode"
        style={{ right: 24, bottom: 24 }}
        // icon={<DarkModeSwitch style={{ transform: "translateX(-2px)" }} checked={isDarkMode} size={18} />}
        onClick={() => dispatch(setTheme({ isDarkMode: !isDarkMode }))}
      />
    </div>
  );
};

export default FloatingButtons;
